import { useState, useEffect, useCallback } from 'react'

// Functions
import isExact from 'functions/is-exact'

const useSelectQuery = (query, groups, selectValueCalculator, getDefaultSelectQuery) => {
	const [oldQuery, setOldQuery] = useState(query);
	const [oldGroups, setOldGroups] = useState(groups);
	const [calculatedSelectQuery, setCalculatedSelectQuery] = useState({});

	const calculateSelectQuery = useCallback((oldQuery, oldGroups) => {
		if(oldGroups && oldGroups.length) { // Gruplar yüklenmeden çekmiyoruz.
			let promises = [];

			for(const key in oldQuery) {
				promises.push(selectValueCalculator(oldQuery[key], key, oldGroups));
			}

			Promise.all(promises).then((values) => {
				let newSelectQuery = getDefaultSelectQuery();

				for(const val of values) {
					if(val) {
						newSelectQuery[val.key] = val.value;
					}
				}
				
				setCalculatedSelectQuery(newSelectQuery);
			});
		}
	}, [selectValueCalculator, getDefaultSelectQuery]);

	useEffect(() => {
		if(!isExact(query, oldQuery)) {
			setOldQuery(query);
		}
	}, [query, oldQuery]);

	useEffect(() => {
		if(!isExact(groups, oldGroups)) {
			setOldGroups(groups);
		}
	}, [groups, oldGroups]);

	useEffect(() => {
		if(selectValueCalculator && getDefaultSelectQuery) {
			calculateSelectQuery(oldQuery, oldGroups);
		}
	}, [oldQuery, oldGroups, calculateSelectQuery, selectValueCalculator, getDefaultSelectQuery]);

	return calculatedSelectQuery;
}

export default useSelectQuery;